import { type ActionItem } from 'shared/ui'
import { type IParamsContactsOptOut } from 'entities/Contacts/api/types'
import { successOpIinHandler } from 'entities/Contacts/lib/successOpIinHandler'
import { type RowContact } from 'entities/Contacts/model/Table/RowContact'
import { contactsDetailsGlobalStore } from 'widgets/ContactsDetails/store'

import { ContactsOptInModalStore } from 'widgets/ContactsOptInModal'
import { type ContactsTableStore } from 'pages/contacts/ui/ContactsTable'

export const getContactsActions = (
  row: RowContact,
  contactsTableStore: ContactsTableStore
): ActionItem[] => {
  const {
    search,
    expandedParams,
    setActiveContact,
    setInActionId,
    loadContacts,
    tableStore,
    selectedModalStore,
  } = contactsTableStore
  const { onRowSelect } = tableStore
  const { openDeleteModal, deleteContacts } = selectedModalStore
  const entities = contactsTableStore.entities

  const resetInActionId = () => {
    setInActionId(null)
  }

  const deleteCallback = () => {
    setInActionId(null)
  }

  const successDeleteCallback = () => {
    setActiveContact(null)
    onRowSelect(row, false)
    loadContacts()
  }

  const opIinHandler = (opt_outs: IParamsContactsOptOut['opt_outs']) => {
    successOpIinHandler(row.origin, opt_outs)
  }

  return [
    {
      text: 'Edit',
      icon: 'edit',
      onAction: () => {
        setActiveContact(row.origin)
        contactsDetailsGlobalStore.openBlockView('contactDetails')
        contactsDetailsGlobalStore.handleChangeCollapse(false)
      },
    },
    {
      text: 'Manage tags',
      icon: 'tag',
      onAction: () => {
        setInActionId(row.id)
        contactsTableStore.contactsTagsModalStore.onOpen({
          ids: [row.id],
          isBulkAll: false,
          filtersList: expandedParams.filtersList,
          searchParams: expandedParams.search,
          callback: () => {
            resetInActionId()
            loadContacts()
          },
          onCloseCallback: resetInActionId,
        })
      },
    },
    {
      text: 'Opt-in status',
      icon: 'shield',
      onAction: () => {
        setInActionId(row.id)
        new ContactsOptInModalStore(entities).handleOpen([row.origin], {
          successHandler: opIinHandler,
          reset: resetInActionId,
          isBulkAll: false,
          filtersList: expandedParams.filtersList,
          search: expandedParams.search,
        })
      },
    },
    {
      text: 'Delete',
      icon: 'delete',
      onAction: () => {
        setInActionId(row.id)
        openDeleteModal({
          selectedIdsLength: 1,
          primaryCallback: () => {
            deleteContacts({
              ids: [row.id],
              search,
              finallyCallback: deleteCallback,
              successCallback: successDeleteCallback,
            })
          },
          onCloseCallback: resetInActionId,
        })
      },
    },
  ]
}
